import artwork from './explore-splash-art.json';

/** A loading illustration, never a basemap or a claim about the player's surroundings. */
export const exploreSplashArt = artwork;
